import React, { memo } from 'react';
import 'components/Footer/footer.scss';

export const DOC_LINKS = {
    dell: {
        privacyPolicy: 'https://www.dell.com/learn/us/en/uscorp1/policies-privacy',
        support: 'https://www.dell.com/support/',
    },
    druva: {
        privacyPolicy: 'https://www.druva.com/privacy-policy',
        support: 'https://www.druva.com/support/',
    },
};

const Footer = memo(({ isDellUser }: { isDellUser: boolean }) => {
    const currentYear = new Date().getFullYear();
    return (
        <footer className="footer">
            <div className="footer-section-druva">
                <h4>
                    <span>Powered by</span>
                    <img src="/druvalogo.svg" alt="Druva" />
                </h4>
            </div>
            <div className="druva-urls">
                <nav>
                    <ul>
                        <li>
                            <a
                                target="_blank"
                                rel="noreferrer"
                                href={DOC_LINKS[isDellUser ? 'dell' : 'druva'].privacyPolicy}
                            >
                                Privacy Policy
                            </a>
                        </li>
                        <li>
                            <a target="_blank" rel="noreferrer" href={DOC_LINKS[isDellUser ? 'dell' : 'druva'].support}>
                                Support
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
            <div className="copyright">
                <p>© {currentYear} Druva Inc.</p>
            </div>
        </footer>
    );
});

export default Footer;
